import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {useParameterFinder} from './useParameterFinder.js';
import '../../Parameters.scss';

const LinkedParameterVisualizer = ({
    scale=1,
    scrollContainer,
    parameter,
    scrollHeight
}) => { 
    let pts = useParameterFinder(parameter, scrollContainer, scale);

    if (pts) {
        let {x1,x2,y1,y2,height1,width1,height2,width2} = pts;
        return (
            <svg width={Math.max(x1,x2,x2+width2,x1+width1)} height={Math.max(y1,y2)} className="parameter-link-visualizer">
              <polygon points={[
                  x1,y1,
                  x2,y2,
                  x2+width2,y2,
                  x1+width1,y1]}/>
            </svg>);
    }
    return [];
}

const mapStateToProps = (state, props) => {
  return {
      parameter: state.effects.accumulatorParameterSelected,
      scrollHeight: props.scrollContainer.current && props.scrollContainer.current.scrollHeight
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkedParameterVisualizer);
